(() => {
  'use strict';
  if (customElements.get('gd-drop-quick-view')) return;
  customElements.define('gd-drop-quick-view', class extends HTMLElement {
    connectedCallback() {
      this.scope = document.getElementById(this.dataset.owner);
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('[data-quick-content]');
      this.status = this.querySelector('[data-quick-status]');
      this.fallback = this.querySelector('[data-quick-fallback]');
      this.zoom = this.querySelector('[data-quick-zoom]');
      if (!this.scope || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.scope.addEventListener('pointerdown', event => {
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false, link: event.target.closest('a.gd-colour-card__link, a.gd-inspo__thumb, a.gd-inspo__name'), track: event.target.closest('[data-gd-card-carousel]') };
      }, options);
      this.scope.addEventListener('pointermove', event => {
        if (this.pointer?.id === event.pointerId && Math.hypot(event.clientX - this.pointer.x, event.clientY - this.pointer.y) > 12) this.pointer.moved = true;
      }, { ...options, passive: true });
      this.scope.addEventListener('pointercancel', event => {
        if (this.pointer?.id === event.pointerId && this.pointer.track) this.pointer.moved = true;
      }, { ...options, passive: true });
      this.scope.addEventListener('scroll', event => {
        if (this.pointer?.track === event.target) this.pointer.moved = true;
      }, { ...options, capture: true, passive: true });
      this.scope.addEventListener('click', event => this.openFromLink(event), options);
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-quick-close]')) this.close(true, event.detail === 0);
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }
        const thumb = event.target.closest('[data-quick-image-index]');
        if (thumb) this.setGalleryIndex(Number(thumb.dataset.quickImageIndex), true);
        if (event.target.closest('[data-quick-prev]')) this.setGalleryIndex(this.imageIndex - 1, true);
        if (event.target.closest('[data-quick-next]')) this.setGalleryIndex(this.imageIndex + 1, true);
        if (event.target.closest('[data-quick-expand]')) this.openZoom();
      }, options);
      this.dialog.addEventListener('change', event => {
        if (event.target.matches('[data-quick-variant]')) this.updateVariant(event.target);
      }, options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(true, true); }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.target.closest('input, select, textarea')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.setGalleryIndex(this.imageIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, options);
      if (this.zoom) {
        this.zoomTrack = this.zoom.querySelector('[data-zoom-track]');
        this.zoomPan = this.zoom.querySelector('[data-zoom-pan]');
        this.zoom.addEventListener('cancel', event => { event.preventDefault(); this.closeZoom(true); }, options);
        this.zoom.addEventListener('click', event => {
          if (event.target.closest('[data-zoom-close]')) this.closeZoom(true);
          if (event.target.closest('[data-zoom-toggle]')) this.toggleZoom();
          if (event.target.closest('[data-zoom-prev]')) this.setZoomIndex(this.zoomIndex - 1);
          if (event.target.closest('[data-zoom-next]')) this.setZoomIndex(this.zoomIndex + 1);
        }, options);
        this.zoom.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            if (this.zoom.querySelector('[data-zoom-stage]').classList.contains('is-zoomed')) return;
            event.preventDefault();
            this.setZoomIndex(this.zoomIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
          if (event.key === '+' || event.key === '=') { event.preventDefault(); this.toggleZoom(true); }
          if (event.key === '-') { event.preventDefault(); this.toggleZoom(false); }
        }, options);
        this.zoomTrack?.addEventListener('scroll', () => {
          if (!this.zoom.open || this.zoomPan && !this.zoomPan.hidden) return;
          clearTimeout(this.zoomScrollTimer);
          this.zoomScrollTimer = setTimeout(() => {
            if (this.zoom.open && this.zoomPan?.hidden && this.zoomTrack.clientWidth) this.setZoomIndex(Math.round(this.zoomTrack.scrollLeft / this.zoomTrack.clientWidth), false);
          }, 90);
        }, { passive: true, signal: this.events.signal });
        window.addEventListener('resize', () => {
          if (this.zoom.open && this.zoomPan?.hidden) this.scrollZoom(false);
        }, options);
        this.bindMouseDrag(this.zoomTrack, this.events.signal, state => {
          this.setZoomIndex(this.mouseGalleryIndex(this.zoomTrack, state.left, this.zoomSlides.length, state.endLeft), false);
          this.scrollZoom(false);
        });
        this.bindMouseDrag(this.zoomPan, this.events.signal, null, true);
      }
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.cleanup(); }, options);
      document.body.addEventListener('product-added-to-cart', event => {
        if (this.dialog.open && event.detail?.form && this.content.contains(event.detail.form)) this.close(false);
      }, options);
    }

    disconnectedCallback() {
      this.close(false);
      this.events?.abort();
    }

    openFromLink(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a.gd-colour-card__link, a.gd-inspo__thumb, a.gd-inspo__name');
      if (!link || !this.scope.contains(link) || link.closest('[data-gd-drop-unavailable="true"]') || link.target === '_blank' || link.hasAttribute('download')) return;
      if (event.detail && this.pointer?.link === link && (this.pointer.moved || Math.hypot(event.clientX - this.pointer.x, event.clientY - this.pointer.y) > 12)) {
        event.preventDefault();
        return;
      }
      let url;
      try { url = new URL(link.href, location.origin); } catch (_) { return; }
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
      event.preventDefault();
      this.open(url, link, event.detail === 0);
    }

    async open(productUrl, opener, keyboard = false) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.opener = opener;
      this.keyboardReturn = keyboard;
      this.cleaned = false;
      this.restoreFocus = true;
      this.content.replaceChildren();
      this.content.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.fallback.href = productUrl.href;
      this.fallback.hidden = true;
      if (!this.dialog.open) {
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }
      this.querySelector('[data-quick-close]').focus({ preventScroll: true });
      const url = new URL(productUrl.href);
      url.searchParams.delete('view');
      url.searchParams.set('section_id', 'gd-drop-product-preview');
      const previewId = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      const timer = setTimeout(() => request.abort(), 10000);
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: request.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Product unavailable');
        const html = await response.text();
        if (request !== this.request || !this.dialog.open) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const product = parsed.querySelector('[data-quick-product]');
        if (!product) throw new Error('Product unavailable');
        product.querySelectorAll('script, iframe, object, embed').forEach(node => node.remove());
        product.querySelectorAll('*').forEach(node => {
          [...node.attributes].forEach(attr => {
            if (/^on/i.test(attr.name) || ((attr.name === 'href' || attr.name === 'src') && /^\s*javascript:/i.test(attr.value))) node.removeAttribute(attr.name);
          });
        });
        this.content.replaceChildren(document.importNode(product, true));
        this.initGallery();
        this.status.textContent = '';
        this.fallback.hidden = true;
      } catch (_) {
        if (request !== this.request || !this.dialog.open) return;
        this.status.textContent = this.dataset.error;
        this.fallback.hidden = false;
      } finally {
        clearTimeout(timer);
        if (request === this.request) this.content.removeAttribute('aria-busy');
      }
    }

    initGallery() {
      this.galleryEvents?.abort();
      this.galleryEvents = new AbortController();
      this.gallery = this.content.querySelector('[data-quick-gallery]');
      this.imageTrack = this.content.querySelector('[data-quick-track]');
      this.slides = Array.from(this.content.querySelectorAll('[data-quick-slide]'));
      if (!this.gallery || !this.imageTrack || !this.slides.length) return;
      this.imageTrack.addEventListener('scroll', () => {
        clearTimeout(this.galleryScrollTimer);
        this.galleryScrollTimer = setTimeout(() => this.setGalleryIndex(Math.round(this.imageTrack.scrollLeft / Math.max(this.imageTrack.clientWidth, 1)), false), 80);
      }, { passive: true, signal: this.galleryEvents.signal });
      this.bindMouseDrag(this.imageTrack, this.galleryEvents.signal, state => {
        this.setGalleryIndex(this.mouseGalleryIndex(this.imageTrack, state.left, this.slides.length, state.endLeft), true, false);
      });
      const initial = this.slides.findIndex(slide => slide.dataset.imageId === this.gallery.dataset.initialImage);
      this.setGalleryIndex(Math.max(0, initial), true, false);
    }

    mouseGalleryIndex(track, startLeft, length, endLeft = track.scrollLeft) {
      const width = Math.max(track.clientWidth, 1);
      const start = Math.round(startLeft / width);
      let index = Math.round(endLeft / width);
      const distance = endLeft - startLeft;
      if (index === start && Math.abs(distance) > Math.max(24, width * 0.18)) index += Math.sign(distance);
      return Math.max(0, Math.min(length - 1, index));
    }

    bindMouseDrag(track, signal, settle, pan = false) {
      if (!track) return;
      const options = { signal };
      let drag = null;
      let suppressUntil = 0;
      const release = (event, aborted = false) => {
        if (!drag || (event && event.pointerId !== drag.id)) return;
        const state = drag;
        drag = null;
        state.endLeft = track.scrollLeft;
        track.style.scrollSnapType = state.snap;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture?.(state.id)) track.releasePointerCapture(state.id);
        if (!state.moved || aborted) return;
        suppressUntil = Date.now() + 700;
        settle?.(state);
      };
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, a, input, select, textarea')) return;
        suppressUntil = 0;
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, top: track.scrollTop, snap: track.style.scrollSnapType, moved: false };
        track.setPointerCapture?.(event.pointerId);
      }, options);
      track.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (!pan && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { release(event, true); return; }
          if ((pan ? Math.hypot(dx, dy) : Math.abs(dx)) < 8) return;
          drag.moved = true;
          track.style.scrollSnapType = 'none';
          track.classList.add('is-dragging');
        }
        event.preventDefault();
        track.scrollLeft = drag.left - dx;
        if (pan) track.scrollTop = drag.top - dy;
      }, { signal, passive: false });
      track.addEventListener('pointerup', release, options);
      track.addEventListener('pointercancel', release, options);
      track.addEventListener('lostpointercapture', release, options);
      track.addEventListener('dragstart', event => event.preventDefault(), options);
      track.addEventListener('click', event => {
        if (!event.detail || Date.now() > suppressUntil) return;
        suppressUntil = 0;
        event.preventDefault();
        event.stopPropagation();
      }, { signal, capture: true });
      signal.addEventListener('abort', () => release(null, true), { once: true });
    }

    setGalleryIndex(index, scroll = true, smooth = true) {
      if (!this.slides?.length) return;
      this.imageIndex = Math.max(0, Math.min(this.slides.length - 1, index));
      const count = `${this.imageIndex + 1} / ${this.slides.length}`;
      this.content.querySelectorAll('[data-quick-image-index]').forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === this.imageIndex)));
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.imageIndex)));
      const label = this.content.querySelector('[data-quick-count]');
      if (label) label.textContent = count;
      this.content.querySelectorAll('[data-quick-prev]').forEach(button => button.disabled = this.imageIndex === 0);
      this.content.querySelectorAll('[data-quick-next]').forEach(button => button.disabled = this.imageIndex === this.slides.length - 1);
      if (scroll && this.imageTrack) this.imageTrack.scrollTo({ left: this.imageIndex * this.imageTrack.clientWidth, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }

    setImage(src) {
      const slideIndex = this.slides?.findIndex(slide => slide.querySelector('img')?.src === src) ?? -1;
      if (slideIndex >= 0) this.setGalleryIndex(slideIndex);
    }

    openZoom() {
      if (!this.zoom || !this.zoomTrack || !this.slides?.length) return;
      clearTimeout(this.galleryScrollTimer);
      const fragment = document.createDocumentFragment();
      this.slides.forEach((slide, index) => {
        const frame = document.createElement('div');
        frame.className = 'gd-quick-zoom__slide';
        frame.dataset.zoomSlide = String(index);
        frame.setAttribute('role', 'group');
        frame.setAttribute('aria-label', `${index + 1} / ${this.slides.length}`);
        const image = document.createElement('img');
        image.dataset.zoomImage = '';
        image.src = slide.querySelector('img').src;
        image.alt = slide.dataset.imageAlt || '';
        image.setAttribute('loading', index === this.imageIndex ? 'eager' : 'lazy');
        image.decoding = 'async';
        image.draggable = false;
        frame.append(image);
        fragment.append(frame);
      });
      this.zoomTrack.replaceChildren(fragment);
      this.zoomSlides = Array.from(this.zoomTrack.children);
      this.zoomIndex = this.imageIndex;
      this.toggleZoom(false);
      if (!this.zoom.open) this.zoom.showModal();
      this.setZoomIndex(this.zoomIndex, false);
      cancelAnimationFrame(this.zoomFrame);
      this.zoomFrame = requestAnimationFrame(() => this.scrollZoom(false));
      this.zoom.querySelector('[data-zoom-close]').focus({ preventScroll: true });
    }

    scrollZoom(smooth = true) {
      if (!this.zoomTrack || !this.zoom?.open) return;
      this.zoomTrack.scrollTo({ left: this.zoomIndex * this.zoomTrack.clientWidth, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }

    setZoomIndex(index, scroll = true) {
      if (!this.zoomSlides?.length) return;
      this.zoomIndex = Math.max(0, Math.min(this.zoomSlides.length - 1, index));
      if (this.zoomPan && !this.zoomPan.hidden) this.toggleZoom(false);
      this.zoomSlides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.zoomIndex)));
      this.zoom.querySelector('[data-zoom-count]').textContent = `${this.zoomIndex + 1} / ${this.zoomSlides.length}`;
      this.zoom.querySelector('[data-zoom-prev]').disabled = this.zoomIndex === 0;
      this.zoom.querySelector('[data-zoom-next]').disabled = this.zoomIndex === this.zoomSlides.length - 1;
      if (scroll) this.scrollZoom();
    }

    toggleZoom(force) {
      if (!this.zoom || !this.zoomPan || !this.zoomTrack) return;
      const stage = this.zoom.querySelector('[data-zoom-stage]');
      const button = this.zoom.querySelector('[data-zoom-toggle]');
      const enabled = force === undefined ? !stage.classList.contains('is-zoomed') : force;
      const image = this.zoomPan.querySelector('[data-zoom-pan-image]');
      const displayed = this.zoomSlides?.[this.zoomIndex]?.querySelector('img').getBoundingClientRect();
      stage.classList.toggle('is-zoomed', enabled);
      this.zoomPan.hidden = !enabled;
      this.zoomTrack.hidden = enabled;
      button.setAttribute('aria-pressed', String(enabled));
      button.setAttribute('aria-label', enabled ? button.dataset.outLabel : button.dataset.inLabel);
      if (enabled) {
        clearTimeout(this.zoomScrollTimer);
        const slide = this.slides?.[this.zoomIndex];
        if (!slide) return;
        image.src = slide.dataset.fullSrc;
        image.alt = slide.dataset.imageAlt || '';
        const center = () => {
          if (!this.zoomPan.hidden) {
            const preview = slide.querySelector('img');
            const naturalWidth = image.naturalWidth || preview.naturalWidth || Number(preview.getAttribute('width')) || 1;
            const naturalHeight = image.naturalHeight || preview.naturalHeight || Number(preview.getAttribute('height')) || 1;
            const scale = Math.min(stage.clientWidth / naturalWidth, stage.clientHeight / naturalHeight);
            this.zoomPan.style.setProperty('--zoom-image-width', `${Math.round((displayed?.width || naturalWidth * scale) * 2)}px`);
            this.zoomPan.style.setProperty('--zoom-image-height', `${Math.round((displayed?.height || naturalHeight * scale) * 2)}px`);
            this.zoomPan.scrollLeft = (this.zoomPan.scrollWidth - this.zoomPan.clientWidth) / 2;
            this.zoomPan.scrollTop = (this.zoomPan.scrollHeight - this.zoomPan.clientHeight) / 2;
          }
        };
        image.onload = center;
        cancelAnimationFrame(this.zoomPanFrame);
        this.zoomPanFrame = requestAnimationFrame(center);
        this.zoomPan.focus({ preventScroll: true });
      } else {
        image.onload = null;
        image.removeAttribute('src');
        this.zoomPan.scrollLeft = 0;
        this.zoomPan.scrollTop = 0;
        if (this.zoom.open) this.scrollZoom(false);
      }
    }

    closeZoom(restore = true) {
      const index = this.zoomIndex;
      const wasOpen = this.zoom?.open;
      clearTimeout(this.zoomScrollTimer);
      cancelAnimationFrame(this.zoomFrame);
      cancelAnimationFrame(this.zoomPanFrame);
      if (wasOpen) this.zoom.close();
      this.toggleZoom(false);
      this.zoomTrack?.replaceChildren();
      this.zoomSlides = [];
      if (restore && wasOpen && this.dialog.open) {
        this.setGalleryIndex(index, true, false);
        this.content.querySelector('[data-quick-expand]')?.focus({ preventScroll: true });
      }
    }

    updateVariant(select) {
      const option = select.selectedOptions[0];
      const price = this.content.querySelector('[data-quick-price]');
      const quantity = this.content.querySelector('[name="quantity"]');
      const full = this.content.querySelector('[data-quick-full]');
      if (!option) return;
      if (price) price.textContent = option.dataset.priceLabel;
      const priceRegion = this.content.querySelector('[data-quick-price-region]');
      if (priceRegion) {
        const onSale = option.dataset.onSale === 'true' && Boolean(option.dataset.compareLabel);
        const compare = priceRegion.querySelector('[data-quick-compare]');
        const comparePrice = priceRegion.querySelector('[data-quick-compare-price]');
        const priceLabel = priceRegion.querySelector('[data-quick-price-label]');
        priceRegion.classList.toggle('gd-price--has-compare', onSale);
        price?.classList.toggle('gd-price__sale', onSale);
        if (compare) compare.hidden = !onSale;
        if (comparePrice) comparePrice.textContent = onSale ? option.dataset.compareLabel : '';
        if (priceLabel) priceLabel.textContent = onSale ? priceRegion.dataset.saleLabel : priceRegion.dataset.regularLabel;
      }
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        quantity.value = quantity.min;
      }
      if (option.dataset.imageId) {
        const index = this.slides?.findIndex(slide => slide.dataset.imageId === option.dataset.imageId) ?? -1;
        if (index >= 0) this.setGalleryIndex(index);
      }
      if (full) { const url = new URL(full.href); url.searchParams.set('variant', option.value); full.href = url.href; }
    }

    close(restoreFocus = true, keyboard = false) {
      this.restoreFocus = restoreFocus;
      this.keyboardReturn = this.keyboardReturn || keyboard;
      this.closeZoom(false);
      this.request?.abort();
      this.request = null;
      if (this.dialog?.open) {
        this.dialog.close();
        this.cleanup();
      }
    }

    cleanup() {
      if (this.cleaned) return;
      this.cleaned = true;
      this.galleryEvents?.abort();
      clearTimeout(this.galleryScrollTimer);
      this.closeZoom(false);
      this.request?.abort();
      this.request = null;
      document.documentElement.style.overflow = this.previousOverflow || '';
      this.content?.replaceChildren();
      if (this.restoreFocus && this.opener?.isConnected) {
        if (this.keyboardReturn) this.opener.focus({ preventScroll: true });
        else if (document.activeElement === this.opener) this.opener.blur();
      }
    }
  });
})();
